import React, { Fragment, useContext} from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { appContext } from "../../../Utils/context";
import {Button} from "reactstrap";


const Step4 = () => {
    const {toggleUserWizard} = useContext(appContext)
 
    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                    <div className="form-wizard-content">
                        <div className="no-results">
                            <div className="sa-icon sa-success animate">
                                <span className="sa-line sa-tip animateSuccessTip" />
                                <span className="sa-line sa-long animateSuccessLong" />
                                <div className="sa-placeholder" />
                                <div className="sa-fix" />
                            </div>
                            <div className="results-subtitle mt-4">User Setup Wizard has Completed!</div>
                            <div className="results-title">
                                Thank You!
                            </div>
                            <div className="mt-3 mb-3" />
                            <div className="text-center">
                                <Button color="success" size="lg" className="btn-shadow btn-wide" onClick={toggleUserWizard}>
                                    Finish
                                </Button>
                            </div>
                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    );
}
export default Step4;
